import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type ThoughtBubbleStepModel from './thought-bubble-step';
import type { TargetingRules } from '../types/thought-bubble';

interface AuditUser {
  id?: string;
  guid?: string;
  first_name?: string;
  last_name?: string;
  person_id?: string;
}

export interface AuditSnapshot {
  user?: AuditUser;
  ts?: string;
  type?: string;
  api?: Record<string, string>;
  service?: Record<string, string>;
  impersonator?: AuditUser;
}

export default class ThoughtBubbleFlowModel extends Model {
  @attr declare name: string;
  @attr declare description: string;
  @attr declare flowType: string;
  @attr declare app: string;
  @attr declare route: string;
  @attr declare status: string;
  @attr declare priority: number;
  @attr declare targetingRules: TargetingRules;
  @attr declare enabledDomains: string[];
  @attr declare createdBy: AuditSnapshot;
  @attr declare updatedBy: AuditSnapshot;
  @attr declare invocationsCount: number;
  @attr declare companyInvocationsCount: number | null | undefined;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @hasMany('thought-bubble-step', { async: false, inverse: 'flow' })
  declare steps: ThoughtBubbleStepModel[];

  [Type] = 'thought-bubble-flow' as const;
}
